import { Link } from 'react-router-dom';

const demos = [
  {
    slug: 'art-search',
    title: 'Art Search AI',
    description: 'Search through 116,000+ artworks using natural language or upload an image to find similar pieces. Powered by ColQwen2 vision-language embeddings.',
    features: [
      'Semantic text search',
      'Image similarity search',
      '3D gallery visualization',
      '116k+ WikiArt artworks',
    ],
    status: 'preview' as const,
  },
];

const Demos = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="container mx-auto px-4 py-6 max-w-7xl">
          <Link
            to="/"
            className="text-sm text-glam-accent hover:underline mb-2 inline-block"
          >
            &larr; Back to Interface Research
          </Link>
          <h1 className="text-3xl font-bold text-glam-primary dark:text-glam-light">
            Interactive Demos
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Explore our AI-powered tools and prototypes
          </p>
        </div>
      </header>

      {/* Demo Grid */}
      <main className="container mx-auto px-4 py-12 max-w-7xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {demos.map((demo) => (
            <Link
              key={demo.slug}
              to={`/demos/${demo.slug}`}
              className="bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 border border-gray-200 dark:border-gray-700"
            >
              <div className="flex items-start justify-between mb-3">
                <h2 className="text-xl font-semibold text-glam-primary dark:text-glam-light">
                  {demo.title}
                </h2>
                {demo.status === 'preview' && (
                  <span className="text-xs bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200 px-2 py-1 rounded-full">
                    Preview
                  </span>
                )}
              </div>
              <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                {demo.description}
              </p>
              <ul className="space-y-1">
                {demo.features.map((feature, i) => (
                  <li
                    key={i}
                    className="text-xs text-gray-500 dark:text-gray-500 flex items-center"
                  >
                    <span className="w-1 h-1 bg-glam-accent rounded-full mr-2" />
                    {feature}
                  </li>
                ))}
              </ul>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Demos;
